import React from 'react'
import {Route, IndexRoute} from 'react-router'
import {routerActions} from 'react-router-redux'
import {UserAuthWrapper} from 'redux-auth-wrapper'

import App from './components/App/App'
import MainScreen from './components/Main/MainScreen'
import LoginScreen from './components/Login/LoginScreen'
import SignupScreen from './components/Signup/SignupScreen'
import ForgetPasswordScreen from './components/ForgetPassword/ForgetPasswordScreen'
import ResetPasswordScreen from './components/ResetPassword/ResetPasswordScreen'
import UserActive from './components/UserActive/UserActive'
import SearchResultScreen from './components/SearchResult/SearchResultScreen'
import BreederSearchResultScreen from './components/SearchResult/BreederSearchResultScreen'
import HorseInfoScreen from './components/HorseInfo/HorseInfoScreen'
import NewHorseScreen from './components/NewHorse/NewHorseScreen'
import PageScreen from './components/Page/PageScreen'
import FeatureScreen from './components/Feature/FeatureScreen'
import SingleFeatureScreen from './components/Feature/SingleFeatureScreen'

import DonateScreen from './components/Donate/DonateScreen'
import PaymentResultScreen from './components/PaymentResult/PaymentResultScreen'

import StoreScreen from './components/Store/StoreScreen'

import AdsMainScreen from './components/Ad/AdsMainScreen'
import AdsByTopicScreen from './components/Ad/AdsByTopicScreen'
import SingleAd from './components/Ad/SingleAdScreen'

import UserScreen from './components/User/UserScreen'
import ProfileScreen from './components/User/Profile/ProfileScreen'
import ProfileEditScreen from './components/User/Profile/ProfileEdit/ProfileEditScreen'
import ChangePasswordScreen from './components/User/ChangePassword/ChangePasswordScreen'
import NotificationScreen from './components/User/Notification/NotificationScreen'
import DashboardScreen from './components/User/Dashboard/DashboardScreen'

import BreederScreen from './components/Breeder/BreederScreen'
import IAmBreederScreen from './components/Breeder/IAmBreederScreen'
import OwnerScreen from './components/Owner/OwnerScreen'
import IAmOwnerScreen from './components/Owner/IAmOwnerScreen'

import HelpScreen from './components/Help/HelpScreen'

import AddHorsePhotoScreen from './components/AddHorsePhoto/AddHorsePhotoScreen'

import NotFoundScreen from './components/Common/NotFound/NotFoundScreen'

const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.auth,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAuthenticated',
  predicate: auth => auth.isAuthenticated
})

const UserIsNotAuthenticated = UserAuthWrapper({
  authSelector: state => state.auth,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsNotAuthenticated',
  // Want to redirect the user when they are done loading and authenticated
  predicate: auth => !auth.isAuthenticated,
  failureRedirectPath: (state, ownProps) => ownProps.location.query.redirect || '/',
  allowRedirectBack: false
})

const Authenticated = UserIsAuthenticated((props) => props.children)

export default (
  <Route path="/" component={App} >
    <IndexRoute component={MainScreen} />
    <Route path="login" component={UserIsNotAuthenticated(LoginScreen)} />
    <Route path="signup" component={SignupScreen} />
    <Route path="forget-password" component={ForgetPasswordScreen} />
    <Route path="reset-password" component={ResetPasswordScreen} />
    <Route path="user-active" component={UserActive} />
    <Route path="result" component={SearchResultScreen} />
    <Route path="breeder-result" component={BreederSearchResultScreen} />
    <Route path="horse/:key" component={HorseInfoScreen} />
    <Route path="page/:key" component={PageScreen} />
    <Route path="new-features" component={FeatureScreen} />
    <Route path="new-feature/:key" component={SingleFeatureScreen} />
    <Route path="donate" component={DonateScreen} />
    <Route path="breeder/:key" component={BreederScreen} />
    <Route path="owner/:key" component={OwnerScreen} />
    <Route path="store" component={StoreScreen} />
    <Route path="ads" component={AdsMainScreen} />
    <Route path="ads/:type" component={AdsByTopicScreen} />
    <Route path="ad/:id" component={SingleAd} />
    <Route path="payment-result" component={PaymentResultScreen} />
    <Route path="help" component={HelpScreen} />
    <Route components={Authenticated}>
      <Route path="new-horse" component={NewHorseScreen} />
      <Route path="i-am-breeder" component={IAmBreederScreen} />
      <Route path="i-am-owner" component={IAmOwnerScreen} />
      <Route path="add-horse-photo" component={AddHorsePhotoScreen} />

    </Route>
    <Route path="user" component={Authenticated}>
      <Route component={UserScreen}>
        <Route path="dashboard" component={DashboardScreen} />
        <Route path="profile" component={ProfileScreen} />
        <Route path="profile-edit" component={ProfileEditScreen} />
        <Route path="change-password" component={ChangePasswordScreen} />
        <Route path="notification" component={NotificationScreen} />
      </Route>
    </Route>
    <Route path="*" component={NotFoundScreen} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js